import { z } from "zod"

export const ApiSignupVerifyParamsSchema = z.object({
  email: z.string().email(),
  firstName: z.string(),
  lastName: z.string(),
  phoneNumber: z.string().nullish(),
  companyName: z.string(),
  smsOptIn: z.boolean(),
  emailMarketingOptIn: z.boolean(),
  trialType: z.enum(["team", "solo"]),
  passwd: z.string().min(8),
})

export type TApiSignupVerifyParams = z.infer<typeof ApiSignupVerifyParamsSchema>

const SignupVerifyErrorCodeEnum = z.enum([
  "email.invalid",
  "size.toobig",
  "matches.invalid",
  "validator.invalid",
  "blank",
  "nullable",
  "signup.index.step_one.blacklisted.ringio",
  "accountCreationCommand.email.zerobounce.validation.invalid",
  "accountCreationCommand.email.zerobounce.validation.temporaryUnavailable",
])

const SignupVerifyErrorFieldEnum = z.enum(["email", "firstName", "lastName", "phoneNumber", "companyName", "passwd", "smsOptIn", "emailMarketingOptIn", "trialType"])

export type TSignupVerifyErrorField = z.infer<typeof SignupVerifyErrorFieldEnum>

export type TSignupVerifyErrorCode = z.infer<typeof SignupVerifyErrorCodeEnum>

const ApiSignupVerifyResponseErrorSchema = z.object({
  code: SignupVerifyErrorCodeEnum,
  defaultMessage: z.string(),
  field: SignupVerifyErrorFieldEnum,
  rejectedValue: z.any(),
})

export type TApiSignupVerifyResponseError = z.infer<typeof ApiSignupVerifyResponseErrorSchema>

export const ApiSignupVerifyResponseCookieSchema = z.object({
  name: z.string(),
  value: z.string(),
  path: z.string(),
  domain: z.string(),
  expires: z.string(),
  maxAge: z.number(),
  secure: z.boolean().optional(),
})

export type TApiSignupVerifyResponseCookie = z.infer<typeof ApiSignupVerifyResponseCookieSchema>

export const ApiSignupVerifyResponseSchema = z.object({
  success: z.boolean(),
  errors: z.array(ApiSignupVerifyResponseErrorSchema).nullish(),
  message: z.string().nullish(),
  cookies: z.array(ApiSignupVerifyResponseCookieSchema),
})

export type TApiSignupVerifyResponse = z.infer<typeof ApiSignupVerifyResponseSchema>

export const ApiSignupCreateParamsSchema = ApiSignupVerifyResponseCookieSchema.array()

export type TApiSignupCreateParams = z.infer<typeof ApiSignupCreateParamsSchema>

const ApiSignupCreateResponseErrorSchema = z.object({
  code: z.string(),
  defaultMessage: z.string(),
  field: z.string(),
  rejectedValue: z.any(),
})

export const ApiSignupCreateResponseSchema = z.object({
  success: z.boolean(),
  errors: z.array(ApiSignupCreateResponseErrorSchema).nullish(),
  message: z.string().nullish(),
})

export type TApiSignupCreateResponse = z.infer<typeof ApiSignupCreateResponseSchema>
